// Calls to the super admin API on the backend (/api/odikai/admin). The backend re-checks every call.
import { auth } from '../firebase';

const ADMIN_API_BASE = `${process.env.REACT_APP_ODIKAI_API_BASE || '/api/odikai'}/admin`;

async function request(method, path, body) {
  const user = auth.currentUser;
  if (!user) throw new Error('Sign in first.');
  // A fresh token: the backend refuses tokens older than an hour
  const token = await user.getIdToken(true);
  const res = await fetch(`${ADMIN_API_BASE}${path}`, {
    method,
    headers: {
      Authorization: `Bearer ${token}`,
      ...(body ? { 'Content-Type': 'application/json' } : {}),
    },
    body: body ? JSON.stringify(body) : undefined,
  });
  let data = null;
  try {
    data = await res.json();
  } catch (e) {
    data = null;
  }
  if (!res.ok) {
    const error = new Error((data && data.error) || `Request failed (${res.status})`);
    error.status = res.status;
    throw error;
  }
  return data;
}

export const adminApi = {
  me: () => request('GET', '/me'),
  health: () => request('GET', '/health'),
  getContent: () => request('GET', '/content').then((d) => d.content),
  updateContent: (sections) => request('PATCH', '/content', sections),
  listUsers: () => request('GET', '/users').then((d) => d.users),
  updateUser: (uid, changes) => request('PATCH', `/users/${encodeURIComponent(uid)}`, changes),
  revokeSessions: (uid) => request('POST', `/users/${encodeURIComponent(uid)}/revoke-sessions`),
  deleteUser: (uid) => request('DELETE', `/users/${encodeURIComponent(uid)}`),
  listPlaybooks: () => request('GET', '/playbooks').then((d) => d.playbooks),
  updatePlaybook: (id, changes) => request('PATCH', `/playbooks/${encodeURIComponent(id)}`, changes),
  deletePlaybook: (id) => request('DELETE', `/playbooks/${encodeURIComponent(id)}`),
};
